import {type ReactElement} from 'react'

import * as classes from './ErrorIcon.classes'

export function ErrorIcon(): ReactElement {
  return <div className={classes.errorIcon} />
}
